import { render, staticRenderFns } from "./countdown.vue?vue&type=template&id=156ff86c&scoped=true"
import script from "./countdown.vue?vue&type=script&lang=js"
export * from "./countdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156ff86c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156ff86c')) {
      api.createRecord('156ff86c', component.options)
    } else {
      api.reload('156ff86c', component.options)
    }
    module.hot.accept("./countdown.vue?vue&type=template&id=156ff86c&scoped=true", function () {
      api.rerender('156ff86c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stiker/countdown.vue"
export default component.exports